<template>
    <div>
        <router-link v-if="$can('change-specific-settings','wallet')" :to="`/wallets/admin/pf/${row.id}`" class="mx-2"><i class="fas fa-cog"></i></router-link>
        <router-link v-if="$can('charge-user-wallet-by-receipt','wallet')" :to="`/wallets/charge-by-receipt/pf/${row.id}`" class="mx-2"><i class="fas fa-receipt"></i></router-link>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            },
        },
        computed: {
            slug() {
                return this.$route.params.slug || this.$route.query.slug;
            }
        },
    })
</script>
